module.exports = __webpack_public_path__ + "img/placeholder.b3dc359a.jpg";